<template>
  <div>
    <div v-for="index in count" :key="index">
      <b-skeleton class="custom-skeleton mb-3" :class="{ 'small': size == 'small', 'medium': size == 'medium', 'large': size == 'large', 'larger': size == 'larger', 'thin__no-margin': size == 'thin__no-margin', 'thin': size == 'thin', 'mb-3': (index < count - 1) }" :animation="animation || 'throb'" width="100%"></b-skeleton>
    </div>
  </div>
</template>

<script>
export default {
  name: 'custom-skeleton',
  props: {
    count: {
      type: Number,
      required: true
    },
    size: {
      type: String,
      required: true
    },
    animation: {
      type: String,
      required: false
    }
  }
};
</script>